/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TagTextDelete/view.blocks to change it.
import Body from 'DesignSystem/Body/index'
import React from 'react'
import TagText from 'DesignSystem/TagText/index'
import XIcon from 'DesignSystem/Svgs/XIcon/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function TagTextDelete({
  children,
  viewPath = "/DesignSystem/TagTextDelete",
  marginTop = 0,
  marginBottom = 4,
  marginRight = 4,
  marginLeft = 0,
  paddingTop = 12,
  paddingBottom = 12,
  paddingRight = 4,
  paddingLeft = 12,
  backgroundColor,
  text = "Blink Orthodontics",
  onClick
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<TagText
  viewPath={`${viewPath}/TagText`}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginRight={marginRight}
 marginLeft={marginLeft}
 paddingTop={paddingTop}
 paddingBottom={paddingBottom}
 paddingRight={paddingRight}
 paddingLeft={paddingLeft}
 backgroundColor={backgroundColor}
>
{childProps => (
<React.Fragment>
<Body
{...childProps}
  viewPath={`${viewPath}/Body`}
 color="rgb(0,150,89)"
 text={text}
 lineHeight={1}
/>
<button
  data-testid="TagTextDelete.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 className={`views-block ${styles.Vertical}`}
>
<XIcon
  viewPath={`${viewPath}/XIcon`}
 width={12}
 height={12}
 stroke="rgb(0,150,89)"
/>
</button>
</React.Fragment>
)}
</TagText>
{children}
</React.Fragment>)
}